import { Component, OnInit } from '@angular/core';
import { AdminService } from './admin.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  adminCredentials: any = {};
  invalidCredentialsAlert = false;

  appointmentSelected = false;
  queriesSelected = false;
  layoutSelected = false;
  subjectsSelected = false;
  servicesSelected = false;
  adminPanelSelected = false;

  adminAuthenticated = false;
  passwordSent = false;
  showOTPfield = false;

  constructor(
    private adminServices: AdminService,
  ) { }

  ngOnInit(): void {
    this.appointmentSelected = true;
    this.queriesSelected = false;
    this.layoutSelected = false;
    this.subjectsSelected = false;
    this.servicesSelected = false;
    this.adminPanelSelected = false;

    if (localStorage.getItem('token')) {
      this.adminAuthenticated = true;
    }

    this.invalidCredentialsAlert = false;
  }

  onAppointmentsSelected() {
    this.appointmentSelected = true;
    this.queriesSelected = false;
    this.layoutSelected = false;
    this.subjectsSelected = false;
    this.servicesSelected = false;
    this.adminPanelSelected = false;
  }

  onQueriesSelected() {
    this.appointmentSelected = false;
    this.queriesSelected = true;
    this.layoutSelected = false;
    this.subjectsSelected = false;
    this.servicesSelected = false;
    this.adminPanelSelected = false;
  }

  onLayoutSelected() {
    this.appointmentSelected = false;
    this.queriesSelected = false;
    this.layoutSelected = true;
    this.subjectsSelected = false;
    this.servicesSelected = false;
    this.adminPanelSelected = false;
  }

  onSubjectsSelected() {
    this.appointmentSelected = false;
    this.queriesSelected = false;
    this.layoutSelected = false;
    this.subjectsSelected = true;
    this.servicesSelected = false;
    this.adminPanelSelected = false;
  }

  onServicesSelected() {
    this.appointmentSelected = false;
    this.queriesSelected = false;
    this.layoutSelected = false;
    this.subjectsSelected = false;
    this.servicesSelected = true;
    this.adminPanelSelected = false;
  }

  onAdminPanelSelected() {
    this.appointmentSelected = false;
    this.queriesSelected = false;
    this.layoutSelected = false;
    this.subjectsSelected = false;
    this.servicesSelected = false;
    this.adminPanelSelected = true;
  }

  onAdminLogin() {
    this.invalidCredentialsAlert = false;
    this.showOTPfield = false;
    this.adminServices.login({
      email: this.adminCredentials.email,
      password: this.adminCredentials.password
    }).subscribe((data: any) => {
      // console.log(data);
      if (data.success === true) {
        // this.adminAuthenticated = true;
        this.showOTPfield = true;
      } else {
        this.invalidCredentialsAlert = true;
      }
    });
    // this.showOTPfield = true;
  }

  onOTPSubmit() {
   // this.adminAuthenticated = true;
    // console.log(this.adminCredentials.OTP);
    this.adminServices.verifyOTP({
      otp: this.adminCredentials.OTP
    }).subscribe(data => {
      // console.log(data);
      if(data['success'] == true){
        this.adminAuthenticated = true;
        localStorage.setItem('token', data['token']);
      } else {
        this.invalidCredentialsAlert = true;
      }
    });
  }

  onForgotPassword() {
    //email id requirement
    this.adminServices.forgetPassword({
      email:'yourstutor17@gmail.com'
    }).subscribe((data:any)=>{
      if(data.success==true) {
        this.passwordSent = true;
      }
    })

  }

  onChangePassword() {

  }

  onLogout() {

  }
}
